export default __webpack_public_path__ + "20bf01955b1ee823c7bc511b8b066242.png";